import React from 'react';
import styled from 'styled-components';
import { CiMoneyBill } from 'react-icons/ci';
import { HiOutlineArrowPath } from 'react-icons/hi2';
import { TbArrowBarDown, TbArrowBarUp } from 'react-icons/tb';



const Container = styled.div`
  background-color: #fff;
  padding: 1rem;
  font-family: 'Montserrat',
 min-height: 90vh;
`;

const HeaderCaisse = styled.div`
  background-color: #ff9f43;
  color: white;
  text-align: center;
  padding: 2rem;
  border-radius: 8px;
  font-size: 1.3rem;
  font-weight: bold;

  p {
    margin: 0;
    font-size: 0.9rem;
    font-weight: normal;
  }
`;

const StatGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-top: 1rem;
`;

const StatCard = styled.div`
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1rem;
  text-align: center;
  font-size: 0.9rem;

  svg {
    font-size: 1.5rem;
    margin-bottom: 0.3rem;
  }

  .value {
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 0.3rem;
    color: #111827;
  }
    .solvla{
    color: #4B5563;
    }
`;

const TransactionsSection = styled.div`
  margin-top: 1.5rem;

  .title-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #4b5563;
    font-weight: 600;
    font-size: 0.95rem;

    .but {
      background: #f3f4f6;
      border: none;
      padding: 0.4rem 0.8rem;
      border-radius: 8px;
      font-size: 0.8rem;
      cursor: pointer;
    }
  }

  .transaction-card {
    margin-top: 1rem;
    padding: 0.8rem;
    background: white;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.9rem;

    .info {
      color: #1f2937;

      small {
        color: #9ca3af;
        display: block;
        font-size: 0.75rem;
      }
    }

    .amount {
      color: #068f7a;
      font-weight: bold;
    }
  }
`;

const IconWrapper = styled.div`
  background-color: #fee2e2; /* fond rouge clair */
  border-radius: 20%;
  padding: 0.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;


const InterfaceMobileOM = ({ omData, transactions, nbrEntree, nbrSortie }) => {
  // Calculer les statistiques
  const totalSolde = omData?.solde || 0;
  const totalEntrees = nbrEntree || 0;
  const totalSorties = nbrSortie || 0;
  const totalTransactions = transactions?.length || 0;

  // Formater le montant
  const formatAmount = (amount) => {
    return new Intl.NumberFormat('fr-FR').format(amount) + ' FCFA';
  };

  return (
    <Container>
      <HeaderCaisse>
        {formatAmount(totalSolde)}
        <p>OM</p>
      </HeaderCaisse>

      <StatGrid>
        <StatCard>
          <CiMoneyBill color="#21E458" size={30}/>
          <div className="value">{formatAmount(totalSolde)}</div>
          <div className='solvla'>Solde Total disponible</div>
        </StatCard>
        <StatCard>
          <TbArrowBarUp color="#2563EB" size={30}/>
          <div className="value">{totalEntrees}</div>
          <div className='solvla'>Nombre total d&apos;entrées</div>
        </StatCard>
       <StatCard>
  <IconWrapper>
    <TbArrowBarDown color="#DC2626" size={24} />
  </IconWrapper>
  <div className="value">{totalSorties}</div>
  <div className="solvla">Nombre total de sorties</div>
</StatCard>
        <StatCard>
          <HiOutlineArrowPath color="#009688" size={30}/>
          <div className="value">{totalTransactions}</div>
          <div className='solvla'>Nombre de transactions</div>
        </StatCard>
      </StatGrid>

      <TransactionsSection>
        <div className="title-bar">
          <span>Transactions</span>
          <button className='but'>Afficher tout</button>
        </div>

        {transactions && transactions.length > 0 ? (
          transactions.slice(0, 5).map((transaction, index) => (
            <div key={index} className="transaction-card">
              <div className="info">
                <strong>{transaction.intitule || 'Transaction'}</strong>
                <small>{transaction.created_at ? new Date(transaction.created_at).toLocaleDateString('fr-FR') : ''}</small>
              </div>
              <div className="amount" style={{ 
                color: transaction.type === 'entree' ? '#068f7a' : '#DC2626' 
              }}>
                {transaction.type === 'entree' ? '+' : '-'} {formatAmount(transaction.montant_total)}
              </div>
            </div>
          ))
        ) : (
          <div className="transaction-card">
            <div className="info">
              <strong>Aucune transaction</strong>
              <small>Aucune transaction Orange Money</small>
            </div>
          </div>
        )}
      </TransactionsSection>
    </Container>
  );
};

export default InterfaceMobileOM;
